// src/utils/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey:            "AIzaSyAfrwx362UjTeACKPQ0WEmNp3Kw8z3ZC94",
  authDomain:        "halro-images.firebaseapp.com",
  projectId:         "halro-images",
  storageBucket:     "halro-images.firebasestorage.app",
  messagingSenderId: "930385444894",
  appId:             "1:930385444894:web:a04b9c2ab27767062eae0f",
};

const app = initializeApp(firebaseConfig);

export const auth           = getAuth(app);
export const db             = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export default app;
